export default {
  path: '/plan',
  name: 'Plan',
  redirect: '/plan/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/plan'),
      meta: { requiresAuth: true }
    },
    {
      path: 'adminPlanList',
      component: () => import('@/views/plan/adminPlanList'),
      meta: { requiresAuth: true }
    },
  ]
}
